export default __webpack_public_path__ + "static/media/metamask-setup_image_2.4f2bf7be.jpg";